// Fixtures für die Produkt-Overviews (#282) — ohne Live-Backend.
export function spamFixture() {
  return {
    available: true,
    monitoring: { hosts: 3, problems: 1, lastCheck: new Date().toISOString() },
    phishing: { domains: 1284, last24h: 37 },
    blocklist: { domains: 5210, hosts: 9120, rpzZones: 2 },
    errors: [],
  };
}
export function a11yFixture() {
  return { available: true, overview: { tenants: 12, scansToday: 48, avgScore: 92.4, openIssues: 133 } };
}
export function scanFixture() {
  return { available: true, overview: { sitesMonitored: 76, findingsOpen: 21, criticals: 2, lastScan: new Date().toISOString() } };
}
export function searchFixture() {
  return { available: true, overview: { indexes: 9, documents: 154203, queries24h: 8123, avgLatencyMs: 14 } };
}
